import React, { PureComponent } from 'react';
import { Header, Button } from 'semantic-ui-react';
import { IN_TO_M, BACKSTOP_OFFSET } from '../../constants';

import './Description.css';

export default class Description extends PureComponent {
  onDelete = () => {
    const {
      selectedModel,
      models,
      setAppState,
      actions,
      configuration,
      appApi,
    } = this.props;
    const { attribute, value, parent } = models[selectedModel];

    let newAppState = actions.removeModel(selectedModel);
    if (parent) {
      // const { attribute: parentAttribute, value: parentValue } = models[parent];
      const {
        dependOnBlock: block,
        secondaryDependOnBlocks: secondaryBlocks,
      } = appApi.config.getModelDependOnBlocks(
        selectedModel,
        configuration,
        models
      );
      block.unoccupyBlocks(selectedModel);
      secondaryBlocks &&
        secondaryBlocks.forEach(secondaryBlock =>
          secondaryBlock.unoccupyBlocks(selectedModel)
        );
    }
    let setConfigAction = {
      attribute,
    };
    configuration[attribute][value] &&
      Object.assign(setConfigAction, { value, change: selectedModel });

    switch (attribute) {
      case 'base':
        setConfigAction = [
          setConfigAction,
          { attribute: 'depth' },
          { attribute: 'width' },
        ];
        break;
      case 'belowPopularBackstop':
        if (configuration.uprights.blocks) {
          const uprightFrontBlock = configuration.uprights.blocks.uprightFront;
          const product = appApi.config.getProduct(models[selectedModel].value);
          const { height } = product;
          uprightFrontBlock.addRows(
            Array(height - BACKSTOP_OFFSET).fill(1 * IN_TO_M)
          );
        }
        break;
      default:
    }
    newAppState = actions.setConfiguration(setConfigAction, newAppState);
    setAppState(newAppState);
  };
  render() {
    const { selectedModel, appApi, models } = this.props;
    const { value } = models[selectedModel];
    const { sceneDescription, label } = appApi.config.getProduct(value);
    return (
      <div className="descriptionContainer">
        <div className="descriptionLeft">
          <Header as="h5">{value}</Header>
          <Button id="deleteButton" onClick={this.onDelete}>
            Delete Selection
          </Button>
        </div>
        <div className="descriptionDivider" />
        <div className="shortDescriptionText">{label}</div>
        <div className="descriptionDivider" />
        <div className="descriptionText">{sceneDescription}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Description/index.js